<template>
  <div class="header-nav">
    <div class="nav-top flex flex-vc">
      <div class="top-main main-con flex flex-hb flex-vc">
        <div class="n-t-left" @click="jump('/home')">
          <img src="@/assets/images/logo.png" alt="" />
        </div>
        <div class="n-t-right flex flex-hb flex-vc">
          <div class="top-seach flex flex-vc flex-ha">
            <input placeholder="输入关键字进行搜索" v-model="keyword" @blur="filterSearch" @keyup.13="filterSearch" />
            <img src="@/assets/images/seach-icon.png" alt="" class="seach-icon" />
          </div>
          <div class="top-text">
            <!-- <span class="cur-poi" @click="$router.push('/personal/personal')">登录</span><span style="padding: 0 10px">|</span><span class="cur-poi">注册</span> -->
            <template v-if="$store.getters.token && $store.getters.userinfo">
              <span class="tx-father cur-poi" @click="$router.push('/personal/personal')">
                <img src="@/assets/images/tx.png" alt="" />
              </span>
              <span class="tx-text cur-poi" @click="$router.push('/personal/personal')">
                {{ $store.getters.userinfo.username }}
              </span>
            </template>
            <template v-else>
              <span class="cur-poi" @click="showDialogFun(1)">登录</span>
              <span style="padding: 0 10px">|</span>
              <span class="cur-poi" @click="showDialogFun(3)">注册</span>
            </template>
          </div>
          <!-- <div class="mobile-nav" @click="drawer = true">
            <img src="@/assets/images/mobile-nav.png" alt="" />
          </div> -->
        </div>
      </div>
    </div>
    <!-- <div class="nav-bottom">
      <div class="nav-bottom-con main-con flex flex-vc flex-hb">
        <div
          :class="['nav-bottom-con-item flex flex-v flex-vc cur-poi', active == 'home' ? 'active' : '']"
          @click="jump('/home')"
        >
          <span>首页</span>
          <img class="sel-icon" src="@/assets/images/navsel-icon.png" alt="" />
        </div>
        <div
          :class="['nav-bottom-con-item flex flex-v flex-vc cur-poi', active == 'TCM' ? 'active' : '']"
          @click="jump('/TCM')"
        >
          <span>中医类别课程</span>
          <img class="sel-icon" src="@/assets/images/navsel-icon.png" alt="" />
        </div>
        <div
          :class="['nav-bottom-con-item flex flex-v flex-vc cur-poi', active == 'WesternMedicine' ? 'active' : '']"
          @click="$store.dispatch('user/changeDialog', { isshow: true, type: 4 })"
        >
          <span>西医类别课程</span>
          <img class="sel-icon" src="@/assets/images/navsel-icon.png" alt="" />
        </div>
        <div
          :class="['nav-bottom-con-item flex flex-v flex-vc cur-poi', active == 'about' ? 'active' : '']"
          @click="jump('/about')"
        >
          <span>联系我们</span>
          <img class="sel-icon" src="@/assets/images/navsel-icon.png" alt="" />
        </div>
      </div>
    </div> -->

    <el-dialog :visible.sync="$store.getters.dialog.isshow" :show-close="false" :close-on-click-modal="false">
      <div class="login-close" @click="onCancelFun">
        <img src="@/assets/images/delete.png" />
      </div>

      <!-- 登录 -->
      <template v-if="$store.getters.dialog.type == 1">
        <span class="login-title">登录</span>
        <div class="login-info">
          <el-form :model="form1">
            <el-form-item>
              <el-input v-model="form1.phone" autocomplete="off" placeholder="手机号"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="form1.password" type="password" autocomplete="off" placeholder="密码"></el-input>
            </el-form-item>
          </el-form>

          <div slot="footer" class="dialog-footer" @click="onLoginFun">
            <label>登录</label>
          </div>
          <div class="login-more">
            <label @click="showDialogFun(2)">忘记密码?</label>
            <label @click="showDialogFun(3)">立即注册</label>
          </div>
        </div>
      </template>

      <!-- 忘记密码 -->
      <template v-if="$store.getters.dialog.type == 2">
        <span class="login-title">忘记密码</span>
        <div class="login-info">
          <el-form :model="form2">
            <el-form-item>
              <el-input v-model="form2.phone" autocomplete="off" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item>
              <div class="send-msg">
                <el-input v-model="form2.captcha" autocomplete="off" placeholder="请输入短信验证码"></el-input>
                <div class="send-msg-btn" v-if="count <= 0" @click="sendCodeFun">点击获取</div>
                <div class="send-msg-btn" v-else style="background: #cccccc">{{ count }}s后重发</div>
              </div>
            </el-form-item>
            <el-form-item>
              <el-input v-model="form2.password" type="password" autocomplete="off" placeholder="新密码"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="form2.repassword" type="password" autocomplete="off" placeholder="确认密码"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <label @click="onUpdatePassFun">确认</label>
          </div>
        </div>
      </template>

      <!-- 注册 -->
      <template v-if="$store.getters.dialog.type == 3">
        <span class="login-title">注册</span>
        <div class="login-info">
          <el-form :model="form3">
            <el-form-item>
              <el-input
                v-model="form3.username"
                autocomplete="off"
                placeholder="请填写真实姓名（注册后不可修改）"
              ></el-input>
              <span>*</span>
            </el-form-item>
            <el-form-item>
              <el-input v-model="form3.phone" autocomplete="off" placeholder="手机号（注册后不可修改）"></el-input>
              <span>*</span>
            </el-form-item>
            <el-form-item>
              <div class="send-msg">
                <el-input v-model="form3.captcha" autocomplete="off" placeholder="请输入短信验证码"></el-input>
                <div class="send-msg-btn cur-poi" v-if="count <= 0" @click="sendCodeFun">点击获取</div>
                <div class="send-msg-btn" v-else style="background: #cccccc">{{ count }}s后重发</div>
              </div>
              <span>*</span>
            </el-form-item>
            <el-form-item>
              <el-select v-model="form3.hospital" filterable placeholder="请选择所在单位">
                <el-option
                  v-for="item in hospitalOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <span>*</span>
            </el-form-item>
            <el-form-item>
              <el-select v-model="form3.is_register_media" placeholder="是否注册新媒体账号">
                <el-option
                  v-for="item in mediaOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <span>*</span>
            </el-form-item>
            <el-form-item>
              <el-input v-model="form3.platform" autocomplete="off" placeholder="所在平台"></el-input>
              <span></span>
            </el-form-item>
            <el-form-item>
              <el-input v-model="form3.account_name" autocomplete="off" placeholder="账号名称"></el-input>
              <span></span>
            </el-form-item>
            <!-- <el-form-item>
              <el-input v-model="form3.keshi" autocomplete="off" placeholder="科室"></el-input>
              <span>*</span>
            </el-form-item> 
            -->
            <el-form-item>
              <el-input v-model="form3.password" type="password" autocomplete="off" placeholder="密码"></el-input>
              <span>*</span>
            </el-form-item>
            <el-form-item>
              <el-input v-model="form3.repassword" type="password" autocomplete="off" placeholder="确认密码"></el-input>
              <span>*</span>
            </el-form-item>
          </el-form>
          <div class="dialog-agree">
            <el-checkbox v-model="form3.checked"></el-checkbox>
            我已阅读并同意
            <span class="cur-poi" @click="goNewPageFun('yonghuxieyi')">《知情同意书》</span>
            和
            <span class="cur-poi" @click="goNewPageFun('yinsixieyi')">《隐私协议》</span>
          </div>
          <div slot="footer" class="dialog-footer cur-poi" @click="onRegisterFun">
            <label class="cur-poi">注册</label>
          </div>
          <label
            class="cur-poi"
            @click="showDialogFun(1)"
            style="display: inline-block; width: 100%; margin-top: 12px; text-align: center; color: #004eba"
          >
            登录
          </label>
        </div>
      </template>

      <!-- 暂未开放 -->
      <template v-if="$store.getters.dialog.type == 4">
        <span class="login-title">提示</span>
        <div class="login-info-1">
          <span>本栏目正在维护中，敬请期待</span>
        </div>
        <label class="no-open" @click="$store.dispatch('user/changeDialog', { isshow: false, type: 0 })">确定</label>
      </template>
    </el-dialog>
    <!-- 
    <el-drawer title="我是标题" :visible.sync="drawer" :with-header="false" size="80%">
      <div class="sjmoble">
        <div class="navtitle">
          <img src="@/assets/images/mobile-nav.png" alt="" @click="drawer = false" />
          <span @click="drawer = false">返回</span>
        </div>
        <div :class="['navitem', active == 'home' ? 'sel' : '']" @click="jump1('/home')">首页</div>
        <div :class="['navitem', active == 'TCM' ? 'sel' : '']" @click="jump1('/TCM')">中医类别课程</div>
        <div
          :class="['navitem', active == 'WesternMedicine' ? 'sel' : '']"
          @click="$store.dispatch('user/changeDialog', { isshow: true, type: 4 })"
        >
          西医类别课程
        </div>
        <div :class="['navitem', active == 'about' ? 'sel' : '']" @click="jump1('/about')">联系我们</div>
      </div>
    </el-drawer> -->
  </div>
</template>

<script>
import { getLogin, getSendSms, getUpdatePass, getRegister, getCompany } from '@/api/postAPI';
import { throttle } from '@/utils/debounce';

export default {
  props: {
    cates: Array,
  },
  data() {
    return {
      drawer: false,
      active: '',
      keyword: '',
      dialogLoginVisible: false,
      dialogType: 3,
      timer: '',
      count: 0,
      form1: {
        phone: '',
        password: '',
      },
      form2: {
        phone: '',
        captcha: '',
        password: '',
        repassword: '',
      },
      form3: {
        username: '',
        phone: '',
        captcha: '',
        hospital: '',
        is_register_media: '', // 是否注册新媒体账号
        account_name: '', // 账号名称
        platform: '', // 所在平台
        keshi: '',
        password: '',
        repassword: '',
        checked: false,
      },
      httpAddr: '',

      hospitalOptions: [], // 医院列表
      mediaOptions: [
        // 是否注册新媒体账号
        {
          value: '是',
          label: '是',
        },
        {
          value: '否',
          label: '否',
        },
      ],
    };
  },
  watch: {
    $route: {
      handler: function (val) {
        this.active = val.name;
      },
      deep: true,
    },
  },
  mounted() {
    this.httpAddr = window.location.origin;
    this.active = this.$route.name;
    getCompany().then((res) => {
      if (res.code == 200) {
        this.hospitalOptions = res.data.map((item) => {
          return {
            value: item.name,
            label: item.name,
          };
        });
      }
    });
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    filterSearch() {
      if (this.keyword) {
        this.$router.replace({ path: '/seachlist', query: { keyword: this.keyword } });
      } else {
        this.$router.push('/');
      }
    },
    jump(path) {
      this.$router.push({ path });
    },
    jump1(path) {
      this.drawer = false;
      this.$router.push({ path });
    },
    goNewPageFun(key) {
      // console.log(window.location)
      window.open(this.httpAddr + '/web/#/agreement?key=' + key, '_blank');
    },

    showDialogFun(type) {
      if (this.$store.getters.dialog.type != type) {
        this.count = 0;
        clearInterval(this.timer);
      }
      // this.dialogType = type;
      // this.dialogLoginVisible = true;
      this.$store.dispatch('user/changeDialog', { isshow: true, type: type });
    },
    onCancelFun() {
      this.$store.dispatch('user/changeDialog', { isshow: false, type: 1 });
      clearInterval(this.timer);
      this.count = 0;
    },

    // 发送短信
    sendCodeFun: throttle(function () {
      let phone =
        this.$store.getters.dialog.type == 2
          ? this.form2.phone
          : this.$store.getters.dialog.type == 3
          ? this.form3.phone
          : '';
      if (!phone || phone.trim() == '') {
        this.$message.error('请输入手机号');
        return;
      } else if (!/^1[3-9]\d{9}$/.test(phone)) {
        this.$message.error('请输入正确的手机号');
        return;
      }
      getSendSms({ phone: phone, type: this.$store.getters.dialog.type == 3 ? 'login' : '' }).then((res) => {
        if (res.code == 200) {
          this.count = 60;
          this.timer = setInterval(() => {
            if (this.count <= 0) {
              clearInterval(this.timer);
            }
            this.count--;
          }, 1000);
        }
      });
    }, 1000),

    onLoginFun: throttle(function () {
      if (!this.form1.phone || this.form1.phone.trim() == '') {
        this.$message.error('请输入手机号');
        return;
      } else if (!/^1[3-9]\d{9}$/.test(this.form1.phone)) {
        this.$message.error('请输入正确的手机号');
        return;
      }
      if (!this.form1.password || this.form1.password.trim() == '') {
        this.$message.error('请输入密码');
        return;
      }
      getLogin(this.form1).then((res) => {
        if (res.code == 200) {
          this.$message.success('登录成功');
          this.$store.dispatch('user/changeDialog', { isshow: false, type: 1 });
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('userinfo', JSON.stringify(res.data));
          this.$store.dispatch('user/changeToken', res.data.token);
          this.$store.dispatch('user/changeUser', res.data);
          location.reload();
        }
      });
    }, 1000),

    onUpdatePassFun: throttle(function () {
      if (!this.form2.phone || this.form2.phone.trim() == '') {
        this.$message.error('请输入手机号');
        return;
      } else if (!/^1[3-9]\d{9}$/.test(this.form2.phone)) {
        this.$message.error('请输入正确的手机号');
        return;
      }
      if (!this.form2.captcha || this.form2.captcha.trim() == '') {
        this.$message.error('请输入短信验证码');
        return;
      }
      if (!this.form2.password || this.form2.password.trim() == '') {
        this.$message.error('请输入新密码');
        return;
      }
      if (!this.form2.repassword || this.form2.repassword.trim() == '') {
        this.$message.error('请确认密码');
        return;
      } else if (this.form2.password != this.form2.repassword) {
        this.$message.error('密码不一致');
        return;
      }
      getUpdatePass(this.form2).then((res) => {
        if (res.code == 200) {
          this.$message.success('修改成功');
          this.$store.dispatch('user/changeDialog', { isshow: true, type: 1 });
        }
      });
    }, 1000),

    onRegisterFun() {
      if (!this.form3.username || this.form3.username.trim() == '') {
        this.$message.error('请输入您的真实姓名');
        return;
      }
      if (!this.form3.phone || this.form3.phone.trim() == '') {
        this.$message.error('请输入手机号');
        return;
      } else if (!/^1[3-9]\d{9}$/.test(this.form3.phone)) {
        this.$message.error('请输入正确的手机号');
        return;
      }
      if (!this.form3.captcha || this.form3.captcha.trim() == '') {
        this.$message.error('请输入短信验证码');
        return;
      }
      if (!this.form3.hospital || this.form3.hospital.trim() == '') {
        this.$message.error('请选择所在单位');
        return;
      }
      if (!this.form3.is_register_media || this.form3.is_register_media.trim() == '') {
        this.$message.error('请选择是否注册新媒体账号');
        return;
      }
      if (!this.form3.password || this.form3.password.trim() == '') {
        this.$message.error('请输入新密码');
        return;
      }
      if (!this.form3.repassword || this.form3.repassword.trim() == '') {
        this.$message.error('请确认密码');
        return;
      } else if (this.form3.password != this.form3.repassword) {
        this.$message.error('密码不一致');
        return;
      }
      if (!this.form3.checked) {
        this.$message.error('请阅读并同意协议');
        return;
      }
      getRegister(this.form3).then((res) => {
        if (res.code == 200) {
          this.$message.success('注册成功');
          this.$store.dispatch('user/changeDialog', { isshow: true, type: 1 });
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
@media screen and (max-width: 768px) {
  .nav-bottom {
    display: none !important;
  }
  .header-nav {
    min-width: auto !important;
    height: auto !important;
  }
  .n-t-left {
    width: 189px !important;
    height: 18px !important;
  }
  .mobile-nav {
    display: inline-block !important;
    width: 20px;
    height: 20px;
    margin-left: 14px;
    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .top-seach {
    width: 170px !important;
    height: 38px !important;
    background: #ffffff;
    border-radius: 50px !important;
    border: 1px solid #cccccc;
    margin-right: 10px !important;
    > input {
      width: 80%;
    }
    .seach-icon {
      width: 17px;
      height: 17px;
    }
  }
  .nav-bottom-con-item {
    font-size: 14px !important;
  }
  .nav-bottom-con {
    padding: 0 10px !important;
  }
  :deep(.el-dialog) {
    width: 90% !important;
    padding: 10px !important;
  }
}
/deep/.el-drawer {
  background: #f3f3f3;
}
.sjmoble {
  padding: 80px 20px;
  box-sizing: border-box;
  .navtitle {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 60px;
    > img {
      width: 20px;
      height: 20px;
      margin-right: 20px;
    }
    > span {
      font-weight: 400;
      font-size: 14px;
      color: #000000;
    }
  }
  .navitem {
    width: 100%;
    height: 45px;
    background: #ffffff;
    border-radius: 44px 44px 44px 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    margin-bottom: 20px;
  }
  .sel {
    background: linear-gradient(90deg, #0fddf4 0%, #004eba 100%);
    border-radius: 44px 44px 44px 44px;
    color: #ffffff;
  }
}
.header-nav {
  width: 100%;
  min-width: 1200px;
  height: 70px;

  .nav-top {
    height: 70px;
    .top-main {
      .n-t-left {
        width: 285px;
        height: 27px;
      }
      .n-t-right {
        .top-seach {
          width: 244px;
          height: 28px;
          background: #ffffff;
          border-radius: 14px 14px 14px 14px;
          border: 1px solid #cccccc;
          margin-right: 30px;
          .seach-icon {
            width: 17px;
            height: 17px;
          }
        }
        .top-text {
          font-weight: 400;
          font-size: 14px;
          color: #000000;
          line-height: 0px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          display: flex;
          align-items: center;
          flex: none;
          .tx-father {
            width: 30px;
            height: 30px;
            display: inline-block;
            > img {
              width: 100%;
              height: 100%;
            }
          }
          .tx-text {
            margin-left: 8px;
            font-weight: 400;
            font-size: 14px;
            line-height: 30px;
            color: #000000;
          }
        }

        .mobile-nav {
          display: none;
        }
      }
    }
  }

  .nav-bottom {
    height: 48px;
    background: url('@/assets/images/nav-bg.png') no-repeat center center;
    background-size: 100% 100%;
    .nav-bottom-con {
      height: 100%;
      .nav-bottom-con-item {
        justify-content: center;
        height: 100%;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        position: relative;
        > span {
          display: block;
        }
        .sel-icon {
          width: 20px;
          height: 10px;
          position: absolute;
          bottom: 0;
          display: none;
        }
      }
      .active {
        color: #004eba;
        .sel-icon {
          width: 20px;
          height: 10px;
          position: absolute;
          bottom: 0;
          display: block;
        }
      }
    }
  }

  :deep(.el-dialog) {
    width: 422px;
    padding: 0 40px;
    border-radius: 8px !important;
    .login-title {
      display: inline-block;
      width: 100%;
      font-weight: 400;
      font-size: 20px;
      color: #2c251d;
      line-height: 0px;
      text-align: center;
    }
    .login-info-1 {
      width: 100%;
      height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 400;
      font-size: 18px;
      color: #969897;
    }
    .no-open {
      display: block;
      width: 120px;
      height: 40px;
      background: #004eba;
      border-radius: 4px 4px 4px 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      margin: 0 auto;
    }
    .login-close {
      position: absolute;
      top: -13px;
      right: -13px;
      width: 25px;
      height: 25px;
      background: #ffffff;
      border-radius: 13px;
      display: flex;
      align-items: center;
      justify-content: center;
      > img {
        width: 22px;
        height: 22px;
        object-fit: cover;
      }
    }
    .login-info {
      width: 100%;

      margin-top: 30px;
    }
    .dialog-footer {
      width: 100%;
      height: 40px;
      background: #004eba;
      border-radius: 4px 4px 4px 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
    }
    .login-more {
      margin-top: 95px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 400;
      font-size: 14px;
      color: #004eba;
    }
    .send-msg {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .send-msg-btn {
        width: 116px;
        height: 40px;
        background: #004eba;
        border-radius: 0px 4px 4px 0px;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .el-input > .el-input__inner {
        border-radius: 4px 0px 0px 4px;
      }
    }
    .el-form-item__content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .el-select {
        flex: 1;
      }
      > span {
        min-width: 14px;
        font-weight: 400;
        font-size: 14px;
        color: #ff0000;
        margin-left: 14px;
      }
    }
    .dialog-agree {
      font-weight: 400;
      font-size: 13px;
      color: #333333;
      margin-bottom: 16px;
      > span {
        color: #004eba;
      }
    }
    .el-dialog__body {
      padding-top: 0;
    }
  }
}
</style>
